import React from 'react'
import { addMinutes, parseISO } from 'date-fns'
import { formatUTC } from 'utils/date'
import api from 'configs/api'
import { alertSuccess, alertDanger } from 'utils/toast'
import { translate } from 'locales'

// Interfaces
import { IDoctorSchedule } from './interfaces'

const asUTCString = (value?: string | null) => {
  if (!value) return value
  return /[zZ]|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`
}

export const findScheduleConfiguration = async (
  setDoctorSchendule: React.Dispatch<React.SetStateAction<IDoctorSchedule[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    const locales = window.localStorage.getItem('@StarBem:lang')

    const dataInStorage: any = window.localStorage.getItem('@StarBem:user')
    const dataPase = JSON.parse(dataInStorage)

    const find = await api.get(`schedule/v1/schedules/doctor/${dataPase.id}`, {
      headers: {
        'Accept-Language': locales || 'pt',
      },
    })

    const items = find.data.schedules

    const scheduleSanitized: IDoctorSchedule[] = items.map((item: any) => ({
      id: item.id,
      start: item.start_time,
      end: item.end_time,
      plans: item.plans,
      occupation: {
        uuid: item.specialty_id,
        name: item.specialty_name,
        language: item.countries,
      },
      status: 'confirmed',
    }))

    setDoctorSchendule(scheduleSanitized)
    setLoading(false)
  } catch (err) {
    console.error(err)
    setLoading(false)
  }
}

export const handleDateClick = (
  eventInfo: any,
  setNewSchedule: React.Dispatch<React.SetStateAction<IDoctorSchedule>>,
  interval?: any
) => {
  const startTime = formatUTC(eventInfo.dateStr, "yyyy-MM-dd'T'HH:mm:ss'Z'")

  const endTime = addMinutes(parseISO(eventInfo.dateStr), interval || 30)

  const recentlyCreatedSchedule: IDoctorSchedule = {
    start: startTime,
    end: formatUTC(endTime, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
    overlap: false,
    status: 'pendent',
  }

  setNewSchedule(recentlyCreatedSchedule)
}

export const handleSaveScheduleConfiguration = async (
  occupations: any,
  selectedOccupation: any,
  setSelectedOccupation: React.Dispatch<React.SetStateAction<any>>,
  country: any,
  selectedCountry: any,
  setSelectedCountry: React.Dispatch<React.SetStateAction<any>>,
  newSchedule: IDoctorSchedule,
  setNewSchedule: React.Dispatch<React.SetStateAction<IDoctorSchedule>>,
  doctorSchedule: any,
  setDoctorSchedule: React.Dispatch<React.SetStateAction<any>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  repeatSchedule: any
) => {
  if (formatUTC(newSchedule.end, 'HH:mm:ss') > '23:45:00') {
    return alertDanger(translate('errors.timeLimit'))
  }

  const countryData: any[] = []

  if (selectedCountry?.includes('BR') && selectedCountry?.includes('CA')) {
    countryData.push(...selectedCountry)
  } else if (selectedCountry?.includes('BR')) {
    countryData.push('PT', 'BR')
  } else if (selectedCountry?.includes('CA')) {
    countryData.push(...selectedCountry)
  }

  const dataInStorage: any = window.localStorage.getItem('@StarBem:user')
  const dataPase = JSON.parse(dataInStorage)

  setLoading(true)
  try {
    const save: any = await api.post('schedule/v1/schedules', {
      specialty_id: selectedOccupation.id,
      day: formatUTC(newSchedule.start, 'yyyy-MM-dd'),
      user_id: dataPase.id,
      start_time: formatUTC(newSchedule.start, 'HH:mm'),
      end_time: formatUTC(newSchedule.end, 'HH:mm'),
      recurrence: repeatSchedule,
      specialty_time: selectedOccupation.attendance_time,
      countries: countryData,
      specialty_name: selectedOccupation.name,
      by_doctor: true,
      groups: [],
    })

    if (Array.isArray(save.data.schedule)) {
      const newSchedulesToAdd: Array<any> = []

      save.data.schedule.map((item: any) => {
        newSchedulesToAdd.push({
          ...newSchedule,
          id: item.id,
          start: `${formatUTC(asUTCString(item.day), 'yyyy-MM-dd')}T${formatUTC(asUTCString(item.start_time), 'HH:mm:ss')}Z`,
          end: `${formatUTC(asUTCString(item.day), 'yyyy-MM-dd')}T${formatUTC(asUTCString(item.end_time), 'HH:mm:ss')}Z`,
          occupation: {
            name: selectedOccupation.name,
            id: selectedOccupation.id,
            language: selectedCountry,
          },
          status: 'confirmed',
        })
      })

      setDoctorSchedule([...doctorSchedule, ...newSchedulesToAdd])

      alertSuccess(translate('success.timeReserved'))

      setSelectedOccupation(occupations[0])
      setNewSchedule({})
      setLoading(false)
    } else {
      setLoading(false)
      alertDanger(save.data?.message)
    }
  } catch (err: any) {
    alertDanger(
      err?.response?.data?.message || translate('errors.errorSaveTimes')
    )
    // setDoctorSchedule([
    //   ...doctorSchedule,
    //   {
    //     ...newSchedule,
    //     id: save.data.schedule.id,
    //     occupation: {
    //       name: selectedOccupation.title,
    //       uuid: selectedOccupation.key,
    //     },
    //     status: 'confirmed',
    //   },
    // ])
    setLoading(false)
  }
  return true
}

export const handleDeleteSchedule = async (
  uuid: string,
  plans: string[],
  doctorSchedule: IDoctorSchedule[],
  setDoctorSchedule: React.Dispatch<React.SetStateAction<IDoctorSchedule[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setLoading(true)

  if (plans?.includes('Plantão')) {
    setLoading(false)
    alertDanger('Plantão não pode ser excluído pela área médica')
    return
  }

  try {
    const del = await api.delete(`schedule/v1/schedules/${uuid}`)

    const doctorScheduleUpdated = doctorSchedule.filter(
      (item: any) => item.id !== uuid
    )

    setDoctorSchedule(doctorScheduleUpdated)

    alertSuccess(del.data.message)

    setLoading(false)
  } catch (err: any) {
    setLoading(false)
    alertDanger(
      err?.response?.data?.message || translate('errors.errorDeleteTimes')
    )
  }
}
